import { subtle } from 'uncrypto'

/**
 * Hash a string using SHA-256 and encode it.
 * @param input - Input string to hash.
 * @param encoding - Desired output encoding.
 * @returns - Encoded hash.
 */
export async function hashSHA256(input: string, encoding: 'base64url' | 'base64' | 'hex' | 'binary') {
  const encoder = new TextEncoder()
  const data = encoder.encode(input)
  const hashBuffer = await subtle.digest('SHA-256', data)

  const hashArray = Array.from(new Uint8Array(hashBuffer))

  if (encoding === 'hex') {
    return Array.from(hashArray).map(b => b.toString(16).padStart(2, '0')).join('')
  }

  const binary = String.fromCharCode(...hashArray)
  if (encoding === 'binary') {
    return binary
  }

  const base64 = btoa(binary)
  if (encoding === 'base64') {
    return base64
  }

  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '') // base64url encoding
}
